import { connect } from 'react-redux';

import RelatedFopsContainer from '../components/partials/RelatedFopsContainer';

export default connect(
  (state, ownProps) => ({
    basket: state.basket,
    betaFeatures: state.user.betaFeatures,
    productsBySku: ownProps.productsBySku || state.products.productsBySku,
    productWarnings: state.basket.productWarnings,
  }),
)(RelatedFopsContainer);
